import { ArrowLeftIcon, Link, LinkActor } from 'internalLibrary';
import { LogoImage, LogoSquareImage } from '../../assets';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from './SimpleNavbar.module.scss';

export type SimpleNavbarProps = {
  onBack?: () => void;
};

export const SimpleNavbar = ({ onBack }: SimpleNavbarProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(
        styles.wrapper,
        // logoLeft ? styles['logo-left'] : undefined,
        // background ? styles['background'] : undefined,
      )}
    >
      <div className={styles['back-wrapper']}>
        <LinkActor
          linkProps={{
            onClick: () => {
              onBack?.();
              window.history.back();
            },
            leftIcon: <ArrowLeftIcon />,
          }}
        >
          <span className={styles['back-text']}>{t('goBack')}</span>
        </LinkActor>
      </div>
      <Link href={process.env.REACT_APP_DASHBOARD_URL}>
        <div className={styles['logo-mobile']}>
          <LogoSquareImage />
        </div>
        <div className={styles['logo-desktop']}>
          <LogoImage />
        </div>
      </Link>
    </div>
  );
};

export default SimpleNavbar;
